import { type MouseEvent, type ReactNode } from 'react';

interface PathwayCardProps {
  /** Route to navigate to (used as the anchor href for SEO + middle-click + reduced-motion users). */
  to: string;
  variant: 'craft' | 'arena';
  eyebrow: string;
  title: ReactNode;
  cta: string;
  bgImage: string;
  /** Called when the card is clicked. Should preventDefault and run the transition. */
  onTrigger: () => void;
}

export function PathwayCard({ to, variant, eyebrow, title, cta, bgImage, onTrigger }: PathwayCardProps) {
  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    // Allow modifier-clicks / middle-clicks to behave normally
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    e.preventDefault();
    onTrigger();
  };

  return (
    <a href={to} className={`card card--${variant}`} onClick={handleClick}>
      <div className="card__bg" aria-hidden="true" style={{ backgroundImage: `url(${bgImage})` }} />
      <div className="card__overlay" aria-hidden="true" />
      <div className="card__content">
        <span className="card__eyebrow">{eyebrow}</span>
        <h2 className="card__title">{title}</h2>
        <span className="card__cta">
          {cta}{' '}
          <span aria-hidden="true">→</span>
        </span>
      </div>
    </a>
  );
}
